import { images } from '../data/site';

export default function About() {
  return (
    <section className="section about" id="about">
      <div className="container about-grid">
        <div className="about-visual"><img src={images.about} alt="Caregiver sharing a warm learning moment with a child" loading="lazy" width="720" height="520" /></div>
        <div className="about-copy">
          <span className="eyebrow">WELCOME TO MINROSE</span>
          <h2>A Little Place for<br />Big Discoveries.</h2>
          <p>Childhood is a wonderful journey filled with questions, discoveries, and important milestones. At Minrose, we believe children deserve an environment where they feel welcomed, encouraged, and supported as they grow.</p>
          <a className="text-link" href="#approach">Get to Know Minrose <span aria-hidden="true">→</span></a>
        </div>
        <div className="about-doodle" aria-hidden="true">Curious<br />Confident<br />Kind<br />Brighter Tomorrows <span>♡</span></div>
      </div>
    </section>
  );
}